module.exports = __webpack_public_path__ + "static/mount-forest-family-health-team-logo-28fe37c6aba48d53b46f0f90c0fb615a.png";